import { postRequest } from "../utils/fetch";
import { formatCalculationDescription, formatItemTotal, formatPrice } from "../utils/price";

const basePath = "/api/v1/OrderService.svc/json/";
export interface IBaseOrderRequest {
	language: string;
	pointOfSaleId: string;
}

export interface IPriceRequest extends IBaseOrderRequest {
	pvc: string;
	quantity: number;
	variableAmount: number;
	options: string[];
	promoCode: string | undefined;
	forceQuantityBreak: number;
	predefinedProductName: string | undefined;
}

export interface ICurrency {
	CurrencyCode: string;
	CurrencySymbol: string;
	DisplayLeftToPrice: boolean;
	DecimalSeparator: string;
}

export interface IPrice {
	Currency: ICurrency;
	Amount: number;
	PriceWithDiscount: number;
	PriceWithoutDiscount: number;
	FormattedPrice: string;
}

export interface IProductPriceDetails {
	Price: IPrice;
	PriceItems: IPriceItem[];
}

export interface IPriceItem {
	Description: string;
	CalculationDescription: string;
	ItemTotal: string;
	Type: string;
}

export function getPrice(
	pvc: string,
	quantity: number,
	variableAmount = 0,
	options: string[] = [],
	promoCode: string | undefined = undefined,
	forceQuantityBreak = -1,
	supClass: string = "",
	predefinedProductName: string | undefined = undefined,
): Promise<IProductPriceDetails> {
	const request: IPriceRequest = {
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		pvc,
		quantity,
		variableAmount,
		options,
		promoCode: promoCode === undefined ? "" : promoCode,
		forceQuantityBreak,
		predefinedProductName,
	};
	return postRequest<IPriceRequest, { GetPriceResult: IProductPriceDetails }>(basePath + "GetPrice", request, {
		headers: new Headers({ "Content-type": "application/json; charset=utf-8" }),
	}).then((res) => {
		res.GetPriceResult.Price.FormattedPrice = formatPrice(
			res.GetPriceResult.Price.PriceWithDiscount,
			res.GetPriceResult.Price.Currency,
			supClass,
		);
		res.GetPriceResult.PriceItems.forEach((item) => {
			if (item.ItemTotal)
				item.ItemTotal = formatItemTotal(
					item.ItemTotal,
					res.GetPriceResult.Price.Currency.CurrencySymbol,
					res.GetPriceResult.Price.Currency.DecimalSeparator,
				);
			if (item.CalculationDescription)
				item.CalculationDescription = formatCalculationDescription(
					item.CalculationDescription,
					res.GetPriceResult.Price.Currency.CurrencySymbol,
					res.GetPriceResult.Price.Currency.DecimalSeparator,
				);
		});
		return res.GetPriceResult;
	}) as Promise<IProductPriceDetails>;
}
